import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { OcurrenceListByAPHType } from './OcurrenceListByAPHType';

const APH = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <OcurrenceListByAPHType />
        </>
    );
};

export default APH;
